import { HomePageLinkType } from "../../products/models/ProductModel";
import { ProductUtils } from "../../products/ProductUtils";
import { ContextualMenuItem } from "../models/OtherTypes"

export type TopBranditemProps = {
    item: ContextualMenuItem;
    size: number;
}

export default function TopCategoryItemView({ item, size }: TopBranditemProps) {
    let url = ProductUtils.getImageUrl(item.imageUrl);

    const imageSize = size * 0.75;

    const onClick = () => {
        window.open(`/products?type=${HomePageLinkType.quickLink}&&key=${item.key}`, "_self");
    }

    return <div className="pv-20 pointer" onClick={onClick} style={{ width: size, display: "inline-flex" }}>
        <div className="center" style={{ width: "100%" }}>
            <img
                src={url}
                alt={item.text}
                width={imageSize}
                height={imageSize}
                className="circle-image"
            />

            <div className="font-smaller pt-10">{item.text}</div>
        </div>
    </div>;
}